import { render, staticRenderFns } from "./JobMatch.vue?vue&type=template&id=58fb7b50"
import script from "./JobMatch.vue?vue&type=script&lang=js"
export * from "./JobMatch.vue?vue&type=script&lang=js"
import style0 from "./JobMatch.vue?vue&type=style&index=0&id=58fb7b50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports